export const Draggables = {
    ROW: 'row',
}
